export default "__VITE_ASSET__7cdcc6e4__"